import api from '@/utils/api';

/**
 * Validate a part number
 * @param {string} companyId - Query to filter companies
 * @param {string} partNumber - The part number to validate
 * @param {string} priceId - The price id
 * @returns {Promise}
 */
const validatePartNumberApi = (companyId, partNumber, priceId) =>
  api.get(`company/${companyId}/price/${priceId}/validate/${partNumber}`);

export default validatePartNumberApi;
